<template>
    <rkm-row>
        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.gestante"
                label="Gestante"
                :disabled="data.model.cidadao.sexoId == this.enums.sexo.MASCULINO || this.calcularIdade()"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.fumante"
                label="Fumante"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.usaAlcool"
                label="Usa álcool"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.outrasDrogas"
                label="Outras drogas"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.hipertensao"
                label="Hipertensão"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>

        <rkm-col cols="2">
            <rkm-form-radio-group
                v-model="data.model.condicao.diabetes"
                label="Diabetes"
            >
                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                <rkm-form-radio :value="false">Não</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>
    </rkm-row>
</template>

<script>
//Moment
import moment from 'moment'

//Enums
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    props: {
        data: { type: Object, required: false, },
    },
    data: () => ({
        enums: {
            sexo
        },
    }),
    methods: {
        calcularIdade() {
            const dataAtual = moment(this.data.form.dataAtual,'DD/MM/YYYY');
            const idade = dataAtual.diff(this.data.model.cidadao.dataNascimento, 'years');

            if (idade < 9 || idade > 60) {

                this.data.model.condicao.gestante = false

                return true;
            }

            return false;
        },
    }
}
</script>